import React from 'react';
import virtualList from 'react-virtual-list';
import AlertIcon from '@material-ui/icons/ErrorOutline';
import List from 'material-ui/List';
import MDItem from './MegaDropItem';
import MDFilterItem from './MegaDropFilterItem';
import EmptyState from '../../../common/EmptyState';

import Console from '../../../../lib/debug';

export default class MDList extends React.Component {
    handleSelect = item => {
        this.props.onItemSelect && this.props.onItemSelect(item);
    };
    render() {
        Console.render('designer.MDList');
        const MIN_ITEMS = 12;
        let view = null;
        let options = [];
        let selectedTags = this.props.selectedTags;
        const itemsList = ({ virtual }) => (
            <List style={virtual.style}>
                {virtual.items.map(item => {
                    if (item.isTag && !item.exercises.length) return null;
                    if (item.category === 'title') {
                        let className =
                            'MegaDrop-item MegaDropItem-category-title';
                        return (
                            <div key={`${item.id}`} className={className}>
                                {item.title}
                            </div>
                        );
                    } else if (item.category === 'separator') {
                        return (
                            <div
                                key={`${item.id}`}
                                className="MegaDrop-item MegaDropItem-separator"
                            >
                                {item.title}
                            </div>
                        );
                    } else {
                        if (!item.isTag) {
                            let isSelected = !this.props.isFilter
                                ? this.props.items[this.props.selectedIndex]
                                      .id === item.id
                                : false;
                            return (
                                <MDItem
                                    itemRef={el =>
                                        (this.props.itemsRef[item.id] = el)
                                    }
                                    key={`${item.id}`}
                                    item={item}
                                    isSelected={isSelected}
                                    onSelect={() => this.handleSelect(item)}
                                />
                            );
                        } else {
                            let tags = [...selectedTags];
                            let isSelected = tags.filter(
                                tag => parseInt(tag.id) === parseInt(item.id)
                            );
                            return (
                                <MDFilterItem
                                    key={`${item.id}`}
                                    item={item}
                                    isSelected={!!isSelected.length}
                                    onSelect={() => this.handleSelect(item)}
                                />
                            );
                        }
                    }
                })}
            </List>
        );
        const virtualOptions = {
            container: this.props.container
        };
        const VirtualItemsList = virtualList(virtualOptions)(itemsList);

        options = (
            <VirtualItemsList
                items={this.props.items}
                itemHeight={!this.props.isFilter ? 29 : 13}
                itemBuffer={3}
            />
        );
        let empty =
            this.props.selectedTags &&
            !this.props.selectedTags.length &&
            this.props.items.length === MIN_ITEMS ? (
                <div className="no-results">No items were found</div>
            ) : null;
        if (this.props.items.length) {
            view = (
                <div className="view items">
                    <div
                        className="content"
                        onMouseLeave={this.props.onLeaveItems}
                    >
                        {options}
                        {empty}
                    </div>
                </div>
            );
        } else {
            view = (
                <div className="view items">
                    <div className="no-results">
                        <EmptyState
                            text="No results found"
                            icon={<AlertIcon />}
                        />
                    </div>
                </div>
            );
        }
        return this.props.show ? view : null;
    }
}
